import user from './user';
import network from './network';

const models = { user, network };

export default models;
